import React from "react"
import TransitionFade from "./transition-fade"
import PropTypes from "prop-types"
import { useAllContent } from "../hooks/use-all-content"
import { useAllTaxo } from "../hooks/use-all-taxo"

const entityLinkParser = {
  external: {
    regex: /^(http|https):/,
    parser: (children, regex, link, allData, allTaxo) => {
      return (
        <a rel="noreferrer" target="_blank" href={link}>
          {children}
        </a>
      )
    },
  },
  internal: {
    regex: /internal:\/(?!node|taxo)/,
    parser: (children, regex, link, allData, allTaxo) => {
      return (
        <TransitionFade link={link.replace(regex, "/")}>
          {children}
        </TransitionFade>
      )
    },
  },
  node: {
    regex: /entity:node\/(\d+)/,
    parser: (children, regex, link, allData, allTaxo) => {
      const drupalId = link.match(regex)[1]
      const processedNode = allData
        .filter(
          ({ node }) => node.drupal_internal__nid == drupalId // eslint-disable-line eqeqeq
        )
        .shift()
      if (processedNode) {
        return (
          <TransitionFade link={processedNode.node.path.alias}>
            {children}
          </TransitionFade>
        )
      }
      return null
    },
  },
  taxonomy: {
    regex: /internal:\/taxonomy\/term\/(\d+)/,
    parser: (children, regex, link, allData, allTaxo) => {
      const drupalId = link.match(regex)[1]
      const processedNode = allTaxo
        .filter(
          ({ node }) => node.drupal_internal__tid == drupalId // eslint-disable-line eqeqeq
        )
        .shift()
      if (processedNode) {
        return (
          <TransitionFade link={processedNode.node.path.alias}>
            {children}
          </TransitionFade>
        )
      }
      return null
    },
  },
  nolink: {
    regex: /^route:<nolink>$/,
    parser: (children, regex, link, allData, allTaxo) => {
      return <>{children}</>
    },
  },
}

const ProcessedLink = ({ children, link }) => {
  const allData = useAllContent()
  const allTaxo = useAllTaxo()
  for (const linkType in entityLinkParser) {
    const typeDef = entityLinkParser[linkType]
    if (typeDef.regex.test(link)) {
      link = typeDef.parser(children, typeDef.regex, link, allData, allTaxo)
    }
  }
  return link
}

ProcessedLink.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired,
  allData: PropTypes.array,
  allTaxo: PropTypes.array,
}

export default ProcessedLink
